(function($) {

    //creates a new vcGallery for each of the matched elements
    $.fn.vcGallery = function(options) {
        /// <summary>Creates the basic vcGallery for each of the selected elements.</summary>
        /// <param name="otpions" type="string">additional options for the plugin.</param>
        /// <returns type="vcGallery">a vcGallery Basic element.</returns>
        var vcV = new window.vcVisual();

        var settings = $.extend({}, $.fn.vcGallery.defaultSettings, options);
        var me = $(this);
        var sLOG_SOURCE = "vcGallery";
        function createBasicElements() {
            // <summary>Creates the elements for showing the the Gallery in a vcForm</summary>
            /// <returns>nothing just adds the element via jquery directly to the website</returns>
            window._VCMQ.addConsumer("vcGallery");
            if ($("#galPopup").length === 0) {
                //create a hidden galleryPopup div if it does not yet exist
                $("<div>").attr("id", "galmask").attr("style", "opacity: 0.8; position:absolute; left: 0; top: 0; z-index:9999; background-color:#f6f6f6;").hide().appendTo("#aspnetForm");
                $("<div>").hide().attr("id", "galPopup").appendTo("#aspnetForm");
                var closeBtn = $("<a>").attr("href", "#").addClass("modalClose").html("<img class=\"modalClose-img\" alt=\"" + window._RESOURCES.JS_Com.closePopup + "\" src=\"../../images/del.gif\">");
                closeBtn.appendTo("#galPopup");
                $("<div>").attr("id", "galPopupContent").attr("style", "overflow:auto; padding: 10px; text-align: left;").appendTo("#galPopup");
            } else {
                $("#galPopup");
            }
            //one consumer for all Gallery elements
            var divMQ;
            if ($("#galMQHidden").length === 0) {
                //create a hidden communications div if it does not yet exist
                divMQ = $("<div>").hide().attr("id", "galMQHidden").appendTo(document.body);
            } else {
                divMQ = $("#galMQHidden");
            }
            return divMQ;
        }


        function fillMediaInformation(mediaInformation) {
            ///<summary>adds information about the media into the popup window</summary>
            ///<param name='mediaInformation'>the information about the file in a JSON-Object</param>
            ///<returns>nothing just adds the element via jquery directly to the website</returns>
            me.val(mediaInformation.mediaID); 
            me.divImageName.html("<a style='max-width:200px; word-wrap:break-word; max-height:30px; display:block;' "/*href='" + mediaInformation.mediaPath + "' download>*/ + "onclick='downloadMediaDataUrl(\"" + mediaInformation.mediaPath.split("media/")[1] + "\")'>" + mediaInformation.mediaName + "</a>");
            if (mediaInformation.mediaType !== "IMAGE") {
                me.image.hide();
                me.imageIcon.show()
                    .addClass($.fn.vcGallery.getIconByEnding(mediaInformation.ending) + " fa-fw");
            } else {
                me.imageIcon.hide();
                //_gwa_
                //me.image.attr("src", mediaInformation.mediaPath).show().load(function() {
                //_gwa_ NEW
   
                me.image.attr("src", getMediaDataUrl(mediaInformation.mediaPath.split("media/")[1])).show().load(function () {
                    settings.onFileLoaded();
                });
            }
            me.divInfo.html(mediaInformation.filesize + (mediaInformation.resolution ? " - " + mediaInformation.resolution : ""));
        }

      
        function showGalleryPopup(html, width, height) {
            ///<summary>opens a own Popup for the Gallery and the fileviewer window width hidden background <br/>
            /// originally taken from show modal popup <br/>
            ///function includes all popup functionality like closing ...</summary>
            try {

                //Get the screen height and width
                var maskHeight = $(document).height();
                var bodyW = $("body").width();
                var docW = $(document).width();
                var maskWidth;
                if (docW > bodyW) {
                    maskWidth = docW;
                } else {
                    maskWidth = bodyW;
                }
                //Set height and width to mask to fill up the whole screen
                $("#galmask").css({ 'width': maskWidth, 'height': maskHeight });
                //transition effect    
                $("#galmask").fadeIn(500);
                $("#galmask").fadeTo("slow", 0.8);
                //Get the window height and width
                var winH = $(window).height();
                var posCurrent = $(window).scrollTop();
                $("#btnFileViewerClose").remove();


                //set size
                $("#galPopup").width(width).height(height).attr("style", "display:block; background-color:#fff; position:absolute; z-index: 10000; border: 1px solid black;");


                $("#galPopupContent").width(width - 20).height(height - 20);

                //readjust if top is too high
                var popupTop = parseInt(posCurrent + (winH / 2 - $("#galPopup").height() / 2), 10);
                if (popupTop <= 0) {
                    popupTop = 5;
                }
                var popupWidth = $("#galPopup").width();
                var popupLeft = maskWidth / 2 - popupWidth / 2;
                if (popupLeft <= 0) {
                    popupLeft = 5;
                }
                //Set the popup window to center
                $("#galPopup").css("top", popupTop);
                $("#galPopup").css("left", popupLeft);
                //set content
                $("#galPopupContent").html(html);
                //transition effect
                $("#galPopup").fadeIn(500);
                //if close button is clicked
                $("#galPopup .modalClose").unbind("click").click(function(e) {
                    //Cancel the link behavior
                    e.preventDefault();
                    $("#galmask").fadeOut(500);
                    $("#galPopup").fadeOut(500);
                });

            } catch (ex) {
                window.writeError(sLOG_SOURCE + "showGalPopup", ex);
            }
        }

        function loadFileViewer() {
            ///<summary>Loads the fileViewerPart of the Gallery showing the file enlarged <br/>
            /// and gives details about it, in a modal popup <br/>
            ///</summary>
            ///<returns>is a sub and returns nothing </returns>
            showGalleryPopup("<div id='divMediaPopup1' class='frame'></div>", 700, 394, true);

            var media = {
                mediaID: me.val().length > 0 ? me.val() : -1,
                height: 374,
                width: 680,
                pos: settings.pos,
                show: true

            };
            vcV.addVisualContentByName("divMedia", "VISUAL_FILEVIEWER", "Popup1", window.getCurrentTimestamp(), 374, 680, JSON.stringify(media), "", 2);
        }

        function loadGallery() {
            ///<summary>calls the visual and loads everything for the file table </summary>
            showGalleryPopup("<div id='gal" + me[0].id.replace("img_", "") + "'></div>", settings.widgetWidth, settings.widgetHeight, false);

            vcV.addVisualBaseByName("gal","VISUAL_GALLERY",me[0].id.replace("img_", ""),window.getCurrentTimestamp(),settings.widgetHeight,settings.widgetWidth,JSON.stringify(me.parameter),"",1);
        }

        function setNoMediaSelected() {
            ///<summary>sets the the divs to the values for no selected media</summary>
            me.image.attr("src", "../../images/no_img.gif").show();
            me.imageIcon.hide();
            me.divImageName.html(window._RESOURCES.JS_Com.noMedia);
            me.divInfo.html(window._RESOURCES.JS_Com.noMediaDetails);
        }

        function removeMediaAssignment() {
            ///<summary> sets the media selected media id to -1 and calls the onFileChanged callback </summary>
            me.val("-1");
            setNoMediaSelected();
            settings.onFileChanged();
        }

        return this.each(function () {
            ///<summary> main function that creates an invidivual gallery for each element that fits the criteria </summary>
            var divMQ = createBasicElements();
            //hide the textElement in use
            me.hide();
            me.parameter = {
                currentImage: me.val().length > 0 && parseInt(me.val(), 10) !== "NaN" ? me.val() : -1,
                mediaType: settings.mediaType,
                mediaCategory: settings.mediaCategory,
                signalType: settings.signalType,
                customerid: settings.customerid
                //inputTag: this.id.replace('img_', '')
            };
            $("#" + this.id + "_mainDiv").remove();
            //create a min Div holder for the extra elements
            var divMain = $("<div>")
                .attr("style", "width:" + settings.formItemWidth + "px; border: solid 1px #dce1e8; height:" + (settings.previewHeight + 6) + "px;")
                .attr("id", this.id + "_mainDiv").addClass("vc-gallery");

            $("<i>")
                .css("cursor", "pointer")
                .css("float", "right")
                .addClass("fa fa-pencil fa-2x fa-fw")
                .css("color", "#004b79")
                .css("margin-top", "2px")
                .css("margin-right", "2px")
                .css("font-size", "22px")
                .attr("title", window._RESOURCES.JS_Com.tip_mediaChange).tipTip({ defaultPosition: "top" })
                .off("click")
                .on({
                    click: function() { loadGallery(); }
                })
                .appendTo(divMain);

            $("<i>")
                .addClass("fa fa-times fa-2x fa-fw icon-color-error")
                .css("cursor", "pointer")
                .css("float", "right")
                .css("margin-top", "30px")
                .css("margin-right", "-29px")
                .attr("title", window._RESOURCES.JS_Com.tip_removeAssignment).tipTip({ defaultPosition: "top" })
                .off("click")
                .on({
                    click: function() { removeMediaAssignment(); }
                })
                .appendTo(divMain);

            //Placeholder div for the Icons/Images to show to only have one element with the click handler 
            var divIcons = $("<div>")
                .attr("id", "img_" + this.id)
                .attr("style", "position: relative; z-index: 1; width:" + settings.previewWidth + "px;height:" + settings.previewHeight + "px;border: solid 1px gray; margin: 2px 0px 2px 2px; float:left;")
                .on({
                    click: function() {
                        loadFileViewer();
                    },
                    mouseover: function() {
                        $(this).css("opacity", 0.4);
                        $(this).css("cursor", "pointer");
                    },
                    mouseout: function() {
                        $(this).css("opacity", 1.0);
                        me.divImageName.css("opacity", 1);
                    }
                })
                .appendTo(divMain);


            me.image = $("<img>")
                .width(settings.previewWidth)
                .height(settings.previewHeight)
                .css("display", "inline")
                .css("z-index", 1)
                .appendTo(divIcons);

            me.imageIcon = $("<i>").hide()
                .css("font-size", settings.previewWidth + "px")
                .css("margin-left", -5 + "px")
                .css("z-index", 1)
                .appendTo(divIcons);


            //the margin for the info divs is the complete width of the image 
            var iInfoMargin = settings.previewWidth + 10; //calculate the maximum length for the div text elements 
            var iTextWidth = settings.formItemWidth - iInfoMargin - 4;

            me.divImageName = $("<div>")
                .attr("type", "text")
                .attr("id", "input_" + this.id)
                .attr("style", "margin-top:5px; margin-bottom:1px; margin-left:" + iInfoMargin + "px; width:" + iTextWidth + "px;  font-weight:bold;")
                .css("z-index", 1);
            me.divImageName.appendTo(divMain);


            me.divInfo = $("<div>")
                .attr("style", "width:" + iTextWidth + "px; margin-left:" + iInfoMargin + "px; margin-bottom:1px; color: gray; font-size:11px;")
                .hide();
            me.divInfo.appendTo(divMain);

            if (settings.showDetails) {
                me.divInfo.html(window._RESOURCES.JS_Com.noMediaDetails).show();
            }
            //add the created div after the textElement
            divMain.insertAfter(me);


            if (me.val() === "" || me.val() === -1) {
                setNoMediaSelected();
            } else {
                //load the data in the tags
                var getParams = {
                    updateType: 5, //load SINGLE Element
                    mediaID: this.value.toString()
                };
                window.VisualCoreService.getData(172, //VisualID
                    "vcGallery", //VCGID
                    window.getCurrentTimestamp(), //Date
                    0, //height
                    0, //width
                    JSON.stringify(me.parameter), //sParameter
                    "", //sSignalParameter
                    2, //DeviceType
                    1, //langid
                    JSON.stringify(getParams), //getParameter
                    function(result) {
                        if (!result || result.length === 0) { //load error show
                            setNoMediaSelected();
                        } else { //show image information
                            fillMediaInformation(jQuery.parseJSON(result));
                        }

                        settings.onFileLoaded();
                    }
                );
            }
            
            if (!settings.showDetails) {
                var tempHeight = settings.previewHeight + 12;
                var iHeight = tempHeight > me.divImageName.offsetHeight ? tempHeight : me.divImageName.offsetHeight;
                divMain.attr("style", divMain.attr("style") + " height:" + iHeight + "px;");
            }

            window._VCMQ.consume(divMQ, "vcGallery", function(event) {
                if (me[0].id === event.values.tag) {

                    switch (event.msg) {
                    case "GAL_FILE_CHOSEN":

                        fillMediaInformation(event.values);
                        settings.onFileChanged();

                        break;
                    default:
                        break;
                    }
                }

            });

        });


    };

    $.fn.vcGallery.getIconByEnding = function (ending) {
        ///<summary> determines the filetype icon according to the filending <br/>
        /// e.g. .pdf ==> fa fa-file-pdf </summary>
        /// <param name="ending"> a string containg the ending </param>
        /// <returns> a string containing the file icon from font awesome </returns>
        var icon;
        switch (ending) {
            /*PDF */
        case ".pdf":
        case ".PDF":
            icon = "fa fa-file-pdf";
            break;

        /* DOC */
        case ".doc":
        case ".DOC":
        case ".DOCX":
        case ".docx": //fallthrough up to here
            icon = "fa fa-file-word";
            break;
        /*EXCEL */
        case ".xls":
        case ".XLS":
            case ".XLSX":
            case ".xlsm":
                icon = "fa fa-file-excel";
                break;
        case ".xlsx":
            icon = "fa fa-file-excel";
            break;

        /*AUDIO */
        case ".mp3":
        case ".MP3":
        case ".ogg":
        case ".OGG":
            icon = "fa fa-file-audio";
            break;

        /* KEEPASS */
        case ".kdb":
        case ".KDB":
        case ".KDBX":
        case ".kdbx":
            icon = "fa fa-lock";
            break;

        /*VIDEO */
        case ".mp4":
        case ".MP4":
            icon = "fa fa-file-video";
            break;

        default:
            icon = "fa fa-file";
            break;

        }
        return icon;

    };


    $.fn.vcGallery.defaultSettings = {
        //<summary> JSON-object containing the default settings for the gallery </summary>
        mediaCategory: "",
        //bluid: "",
        signalType: "",
        showDetails: true,
        //Visual Settings
        previewWidth: 50,
        previewHeight: 50,
        pos: "right",
        formItemWidth: 300,
        widgetHeight: 750,
        widgetWidth: 1024,
        //Callback Functions
        onFileLoaded: function() {},
        onFileChanged: function() {}

    };
})(jQuery);